import React, { Component } from "react";
import { Form, Row, Col, Button, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { PacmanLoader } from "react-spinners";
import "containers/common/Detail.css";
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import "react-table/react-table.css";
import Moment from "moment";
import DatePicker from "react-datepicker";

export default class SLMLeaseList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searching: false,
      isLoading: true,
      leases: [],
      filter: {},
    };

    this.deleteLease = this.deleteLease.bind(this);
  }

  async componentDidMount() {
    console.log("In LeaseList componentDidMount");
    if (!this.props.isAuthenticated) {
      // if false
      return;
    }

    // try {
    //     const leases = await this.getLeases(this.props.filter);
    //     this.setState({ leases });
    // } catch (e) {
    //     alert(e);
    // }

    this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this.setState({ leases: [] });
  }

  deleteLease(leaseid) {
    return API.del("colin", "/slmlease", { queryStringParameters: leaseid });
  }

  handleInputChange = (cellInfo, event) => {
    let data = [...this.props.data];
    data[cellInfo.index][cellInfo.column.id] = event.target.value;
    data[cellInfo.index].modified = true;
    this.setState({ data });
  };
  handleNumberChange = (cellInfo, event) => {
    let data = [...this.props.data];
    let val = event.target.value.replace(/[^0-9]/g, "");

    data[cellInfo.index][cellInfo.column.id] = val;
    data[cellInfo.index].modified = true;
    this.setState({ data });
  };
  handleCheckboxChange = (cellInfo, event) => {
    let data = [...this.props.data];
    data[cellInfo.index][cellInfo.column.id] = event.target.checked;
    data[cellInfo.index].modified = true;
    this.setState({ data });
  };

  handleDateChange = (cellInfo, event) => {
    let addresses = [...this.props.data];
    addresses[cellInfo.index][cellInfo.column.id] = new Date(event);
    addresses[cellInfo.index].modified = true;
    this.setState({ addresses });
  };
  renderEditable = (cellInfo) => {
    const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

    switch (typeof cellValue) {
      case "boolean":
        return (
          <Form.Check
            checked={cellValue}
            onChange={this.handleCheckboxChange.bind(null, cellInfo)}
            label=""
            type="checkbox"
            // onBlur={this.handleSave.bind(null, cellInfo)}
          />
        );

      case "number":
        return (
          <input
            onChange={this.handleNumberChange.bind(null, cellInfo)}
            // onBlur={this.handleSave.bind(null, cellInfo)}
            type="number"
            className="no-border form-control"
            value={cellValue != null ? cellValue : " "}
          />
        );

      default:
        if (cellInfo.column.id.indexOf("date") >= 0) {
          return (
            <DatePicker
              selected={cellValue != null ? new Date(cellValue) : ""}
              onChange={this.handleDateChange.bind(null, cellInfo)}
              // onBlur={this.handleSave.bind(null, cellInfo)}
              dateFormat="dd/MM/yyyy"
              className="no-border form-control"
            />
          );
        } else {
          return (
            <input
              onChange={this.handleInputChange.bind(null, cellInfo)}
              // onBlur={this.handleSave.bind(null, cellInfo)}
              type="text"
              className="no-border form-control"
              value={cellValue != null ? cellValue : ""}
            />
          );
        }
    }
  };

  renderTable(leases) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const numberFormatter = new Intl.NumberFormat("en-AU", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const columns = [
      {
        id: "selected",
        Header: "",
        maxWidth: 60,
        accessor: "selected",
        Cell: this.renderEditable,
        style: { textAlign: "center" },
      },
      {
        id: "lease_id",
        Header: "Lease ID",
        maxWidth: 60,
        accessor: "lease_id",
        Cell: (e) => (
          <LinkContainer
            to={{
              pathname: `../slmleases/${e.value}`,
              state: {
                data: this.props.data
                  .filter((a) => {
                    if (a.selected) {
                      return true;
                    } else {
                      return false;
                    }
                  })
                  .map((a) => a.lease_id),
              },
            }}
          >
            <a>{e.value}</a>
          </LinkContainer>
        ),
      },
      {
        id: "building_name",
        Header: "Building Name",
        accessor: "building_name",
        style: { "white-space": "unset" },
      },
      {
        id: "street_address",
        Header: "Address",
        accessor: "street_address",
        style: { "white-space": "unset" },
      },
      {
        id: "suburb",
        Header: "Suburb",
        accessor: "suburb",
      },
      {
        id: "state_code",
        Header: "State",
        maxWidth: 60,
        accessor: "state_code",
      },
      {
        id: "postcode",
        Header: "Postcode",
        maxWidth: 60,
        accessor: "postcode",
      },
      {
        id: "floor_unit",
        Header: "Suite/Level",
        maxWidth: 60,
        accessor: "floor_unit",
      },
      {
        id: "lease_type",
        Header: "Type",
        accessor: "lease_type",
        style: { "white-space": "unset" },
      },
      {
        id: "stat_date",
        Header: "Stat Date",
        maxWidth: 70,
        accessor: (d) => {
          if (d.stat_date) {
            return Moment(d.stat_date).local().format("DD-MM-YYYY");
          } else {
            return null;
          }
        },
        sortMethod: (a, b) => {
          if (a === b) {
            return 0;
          }
          return new Date(a.split("-")[2], a.split("-")[1] - 1, a.split("-")[0]) > new Date(b.split("-")[2], b.split("-")[1] - 1, b.split("-")[0]) ? 1 : -1;
        },
      },
      {
        id: "rent",
        Header: "Rent Per SQM",
        accessor: (d) => {
          return formatter.format(d.rent);
        },
        sortMethod: (a, b) => {
          if (parseFloat(a.replace("$", "").replace(",", "")) === parseFloat(b.replace("$", "").replace(",", ""))) {
            return 0;
          }
          return parseFloat(a.replace("$", "").replace(",", "")) > parseFloat(b.replace("$", "").replace(",", "")) ? 1 : -1;
        },
      },
      {
        id: "tenant_area",
        Header: "Area",
        maxWidth: 80,
        accessor: (d) => {
          return numberFormatter.format(d.tenant_area);
        },
        sortMethod: (a, b) => {
          if (parseFloat(a.replace("$", "").replace(",", "")) === parseFloat(b.replace("$", "").replace(",", ""))) {
            return 0;
          }
          return parseFloat(a.replace("$", "").replace(",", "")) > parseFloat(b.replace("$", "").replace(",", "")) ? 1 : -1;
        },
      },
      {
        id: "rent_per_annum",
        Header: "Rent Per Annum",
        accessor: (d) => {
          return formatter.format(d.rent_per_annum);
        },
        sortMethod: (a, b) => {
          if (parseFloat(a.replace("$", "").replace(",", "")) === parseFloat(b.replace("$", "").replace(",", ""))) {
            return 0;
          }
          return parseFloat(a.replace("$", "").replace(",", "")) > parseFloat(b.replace("$", "").replace(",", "")) ? 1 : -1;
        },
      },
      {
        id: "broad_space_use_code",
        Header: "Broad Space",
        accessor: "broad_space_use_code",
        style: { "white-space": "unset" },
      },
      {
        id: "space_use_name",
        Header: "Space Use",
        accessor: "space_use_name",
        style: { "white-space": "unset" },
      },
      {
        id: "agent",
        Header: "Agent",
        accessor: "agent",
        style: { "white-space": "unset" },
      },
      {
        id: "agency",
        Header: "Agency",
        accessor: "agency",
        style: { "white-space": "unset" },
      },
      {
        id: "lessee",
        Header: "Lessee",
        accessor: "lessee",
        style: { "white-space": "unset" },
      },
      // ,
      // {
      //     Header: '',
      //     accessor: 'lease_id',
      //     Cell: row => <button onClick={(e) => this.handleDeleteLease(row.value,e)}>Delete</button>
      // }
    ];

    if (!leases) {
      return null;
    } else {
      return <ReactTable data={leases} columns={columns} defaultPageSize={100} className="-striped -highlight" />;
    }
  }

  renderTable2(leases) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    const columns = [
      {
        id: "lease_id",
        Header: "Lease ID",
        accessor: "lease_id",
        maxWidth: 60,
        Cell: (e) => (
          <LinkContainer to={{ pathname: `../slmleases/${e.value}`, state: { data: this.props.data.map((a) => a.lease_id) } }}>
            <a> {e.value} </a>
          </LinkContainer>
        ),
      },
      {
        id: "lease_level",
        Header: "Suite / Level",
        maxWidth: 60,
        accessor: "lease_level",
        style: { "white-space": "unset" },
      },
      {
        id: "lease_type",
        Header: "Type",
        accessor: "lease_type",
      },
      {
        id: "stat_date",
        Header: "Stat Date",
        maxWidth: 70,
        accessor: (d) => {
          if (d.stat_date) {
            return Moment(d.stat_date).local().format("DD-MM-YYYY");
          } else {
            return null;
          }
        },
      },
      {
        id: "note_data",
        Header: "Lease Notes",
        accessor: "note_data",
        style: { "white-space": "unset" },
        minWidth: 120,
        Cell: (cellInfo) => <Form.Control readOnly value={cellInfo.original.note_data} as="textarea" type="text" rows="1" />,
      },
      {
        id: "rent_per_sqm",
        Header: "Rent Per SQM",
        accessor: (d) => {
          if (d.rent_per_annum > 0 && d.tenant_area > 0) {
            return formatter.format(d.rent_per_annum / d.tenant_area);
          } else {
            return 0;
          }
        },
      },
      {
        id: "tenant_area",
        maxWidth: 70,
        Header: "Tenant Area",
        accessor: "tenant_area",
      },
      {
        id: "rent_per_annum",
        Header: "Rent Per Annum",
        maxWidth: 100,
        accessor: (d) => {
          return formatter.format(d.rent_per_annum);
        },
      },
      {
        id: "broad_space_use_code",
        Header: "Broad Use",
        accessor: "broad_space_use_code",
        style: { "white-space": "unset" },
      },
      {
        id: "space_use_name",
        Header: "Space Use",
        accessor: "space_use_name",
        style: { "white-space": "unset" },
      },
      {
        id: "agent",
        Header: "Agent",
        accessor: "agent",
        style: { "white-space": "unset" },
      },
      {
        id: "agency",
        Header: "Agency",
        accessor: "agency",
        style: { "white-space": "unset" },
      },
      {
        id: "lessee",
        Header: "Lessee",
        accessor: "lessee",
        style: { "white-space": "unset" },
      },
      {
        Header: "",
        accessor: "lease_id",
        maxWidth: 60,
        Cell: (e) => (
          <LinkContainer to={{ pathname: `/slmleases/new`, state: { clone: e.original } }}>
            <Button type="button" size="sm" variant="primary">
              Clone
            </Button>
          </LinkContainer>
        ),
      },
    ];

    if (!leases) {
      return null;
    } else {
      return <ReactTable data={leases} columns={columns} defaultPageSize={5} className="-striped -highlight" />;
    }
  }

  selectAll = (event) => {
    let leases = [...this.props.data];
    for (var i = 0; i < leases.length; i++) {
      leases[i].selected = true;
    }
    this.setState({ leases });
  };

  deselectAll = (event) => {
    let leases = [...this.props.data];
    for (var i = 0; i < leases.length; i++) {
      leases[i].selected = false;
    }
    this.setState({ leases });
  };

  renderLeases() {
    return (
      <div className="leases">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        <Row>
          <Col className="text-left">
            <Nav className="justify-content-start">
              {this.props.controlType !== "table2" && (
                <Nav.Item>
                  <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>
                    Select All
                  </Button>{" "}
                </Nav.Item>
              )}
              {this.props.controlType !== "table2" && (
                <Nav.Item>
                  <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>
                    Deselect All
                  </Button>{" "}
                </Nav.Item>
              )}
            </Nav>
          </Col>
          {this.props.controlType === "table2" && (
            <Col>
              <h5>LEASED/For Lease Transactions</h5>
            </Col>
          )}
          <Col className="text-right">
            {this.props.controlType === "table2" && (
              <LinkContainer to={{ pathname: `/slmleases/new`, state: { address_id: this.props.addressid, address_hard_sequence: this.props.hardsequence, building_name: this.props.buildingname, floor_unit: this.props.floorunit, street_no_low: this.props.streetnolow, street_no_high: this.props.streetnohigh, street_name: this.props.streetname, extension: this.props.extension, suburb: this.props.suburb, state_code: this.props.statecode, postcode: this.props.postcode } }}>
                <Button variant="primary" type="button" size="sm">
                  Add
                </Button>
              </LinkContainer>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <b>
              {this.props.data ? this.props.data.length : "0"} of {this.props.data ? (this.props.data.length > 0 ? this.props.data[0].result_count : "0") : "0"} records returned.
            </b>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12}>
            {!this.state.isLoading ? (this.props.controlType === "table2" ? this.renderTable2(this.props.data) : this.renderTable(this.props.data)) : ""}
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    return <div className="LeaseList">{this.props.isAuthenticated ? this.renderLeases() : console.log("error)")}</div>;
  }
}
